import constants from '../helpers/constants';
import { LockScroll } from '../helpers/helpers';

const MOBILE_MENU_ELEMENT = {
  menu: 'mobile-menu',
  button: '.js-menu-btn',
  showClass: 'is-show',
  menuLink: '.js-nav-link',
  activeClass: 'is-active',
  navItem: '.js-nav-item',
};

/**
 * закртыие всех подменю, за исключением текущего
 * @param currentNavItem {HTMLElement} - текущий пункт меню
 */
function closeSubmenu(currentNavItem) {
    const navItem = document.querySelectorAll(MOBILE_MENU_ELEMENT.navItem);
    navItem.forEach((el) => {
        if (el !== currentNavItem) {
            el.classList.remove(MOBILE_MENU_ELEMENT.activeClass);
        }
    });
}

/**
 * открытия/закрытия меню
 * @param menu {HTMLElement} - мобильное меню
 * @param button {HTMLElement} - кнопка котрытия/закрытия мобильное меню
 */
function toggleMenu(menu, button) {
    button.addEventListener('click', () => {
        menu.classList.toggle(MOBILE_MENU_ELEMENT.showClass);
        button.classList.toggle(MOBILE_MENU_ELEMENT.activeClass);

        if (menu.classList.contains(MOBILE_MENU_ELEMENT.showClass)) {
            LockScroll.lock();
        } else {
            LockScroll.unLock();
        }
    });
}

/**
 * открытия/закрытия подменю
 * @param menuLinks {NodeList} - ссылки из меню
 */
function toggleSubMenu(menuLinks) {
    menuLinks.forEach((menuLink) => {
        const linkWrap = menuLink.closest(MOBILE_MENU_ELEMENT.navItem);
        if (!linkWrap) return false;
        if (window.innerWidth < constants.desktopWidth) {
            menuLink.addEventListener('click', () => {
                closeSubmenu(linkWrap);
                linkWrap.classList.toggle(MOBILE_MENU_ELEMENT.activeClass);
            });
        } else {
            linkWrap.addEventListener('mouseenter', () => {
                linkWrap.classList.add(MOBILE_MENU_ELEMENT.activeClass);
            });
            linkWrap.addEventListener('mouseleave', () => {
                linkWrap.classList.remove(MOBILE_MENU_ELEMENT.activeClass);
            });
        }
    });
}

function mobileMenu() {
    const menu = document.getElementById(MOBILE_MENU_ELEMENT.menu);
    if (!menu) { return false; }

    const menuBtn = document.querySelector(MOBILE_MENU_ELEMENT.button);
    const menuLinks = menu.querySelectorAll(MOBILE_MENU_ELEMENT.menuLink);
    toggleMenu(menu, menuBtn);
    toggleSubMenu(menuLinks);
}

export default mobileMenu;
